import type { FolderStructure } from "../../types";

// Switcher order; only the structures the suggestion supports are shown.
export const FOLDER_STRUCTURE_ORDER: readonly FolderStructure[] = [
  "level",
  "building",
  "buildingAndLevel",
  "trade",
];
